module.exports = __webpack_public_path__ + "static/media/Item 26.ad35f6e3.jpg";